module.exports = __webpack_public_path__ + "img/PREDIZE_LOGO.9e04f5cf.png";